import { GrowthOverviewGranularity } from "../const";

export const normalizeGrowthOverviewGranularity = (
    granularity: GrowthOverviewGranularity | string | undefined,
): GrowthOverviewGranularity => {
    if (
        granularity != null &&
        Object.values(GrowthOverviewGranularity).includes(granularity as GrowthOverviewGranularity)
    ) {
        return granularity as GrowthOverviewGranularity;
    }

    return GrowthOverviewGranularity.Monthly;
};
